<template>
  <div>
    <img src="/images/euronicslogo.png" alt="Euronics Group Denmark A/S">
  </div>
</template>
